module.exports = __webpack_public_path__ + "img/lipinku_ic_gift@2x.0bcd5f91.png";